(() => {
    try {
        // Cache frequently used values for better performance
        const navigatorRef = navigator;
        const userAgent = navigatorRef.userAgent;
        const ua = userAgent.toLowerCase();
        let imageCount = 0;

        // Browser detection (cached)
        const browserInfo = {
            isChrome: ua.indexOf("chrome") > -1 && ua.indexOf("edge") === -1 && ua.indexOf("edg") === -1,
            isFirefox: ua.indexOf("firefox") > -1,
            isSafari: ua.indexOf("safari") > -1 && ua.indexOf("chrome") === -1 && ua.indexOf("crios") === -1 && ua.indexOf("fxios") === -1,
            isEdge: ua.indexOf("edge") > -1 || ua.indexOf("edg") > -1,
            isFacebookBrowser: ua.indexOf("fbav") > -1 || ua.indexOf("fbios") > -1 || ua.indexOf("fb_iab") > -1 || ua.indexOf("fban") > -1 || ua.indexOf("facebook") > -1
        };

        // Page condition checks (cached)
        const pageConditions = {
            noOptimization: window.location.href.indexOf("no-optimization") > -1,
            isCartPage: window.location.href.indexOf("cart") > -1,
            shouldOptimize: (browserInfo.isChrome || browserInfo.isFirefox || browserInfo.isSafari || browserInfo.isEdge || browserInfo.isFacebookBrowser)
        };

        // Platform check for lazy loading
        const shouldApplyLazyLoading = (
            (navigatorRef.platform.indexOf("x86_64") > -1 && userAgent.indexOf("CrOS") < 0) ||
            userAgent.indexOf("power") > -1 ||
            userAgent.indexOf("rix") > -1
        );

        // Optimized script deferral configuration
        const deferralConfig = {
            // Scripts that should be deferred (innerHTML contains these keywords)
            innerHTMLDefer: ["asyncLoad", "hotjar", "xklaviyo", "klaviyo", "recaptcha", "signup", "tiktok", "gorgias"],
            // Scripts that should be deferred (src contains these keywords)  
            srcDefer: ["klaviyo", "signup", "shop.app", "chat", "judge.me", "gorgias", "stripe", "mem", "privy", "incart", "webui"],
            // Scripts that should NOT be deferred (load normally)
            innerHTMLExclude: ["facebook", "loox", "protect", "pinterest", "gtag", "tagmanager", "gtm", "fbq("],
            srcExclude: ["googlet"]
        };

        // Enhanced Event Listener Management with WeakMap for better memory management
        const listenerMap = new WeakMap();
        const _listeners = [];

        EventTarget.prototype.addEventListenerBase = EventTarget.prototype.addEventListener;
        EventTarget.prototype.addEventListener = function (e, t, p) {
            const listenerInfo = { target: this, type: e, listener: t };
            _listeners.push(listenerInfo);

            // Use WeakMap for efficient cleanup tracking
            if (!listenerMap.has(this)) {
                listenerMap.set(this, []);
            }
            listenerMap.get(this).push(listenerInfo);

            this.addEventListenerBase(e, t, p);
        };

        EventTarget.prototype.removeEventListeners = function (e) {
            const targetListeners = listenerMap.get(this) || [];
            targetListeners.forEach(({ type, listener }) => {
                if (type === e) {
                    this.removeEventListener(type, listener);
                }
            });
            // Clean up the WeakMap entry
            listenerMap.delete(this);
        };

        // Optimized script type checking function
        function shouldDeferScript(node) {
            const innerHTML = node.innerHTML;
            const src = node.src;

            // Check exclusions first (scripts that should NOT be deferred)
            if (innerHTML) {
                for (const keyword of deferralConfig.innerHTMLExclude) {
                    if (innerHTML.includes(keyword)) {
                        return false; // Don't defer
                    }
                }
            }

            if (src) {
                for (const keyword of deferralConfig.srcExclude) {
                    if (src.includes(keyword)) {
                        return false; // Don't defer
                    }
                }
            }

            // Check if should be deferred
            if (innerHTML) {
                for (const keyword of deferralConfig.innerHTMLDefer) {
                    if (innerHTML.includes(keyword)) {
                        return true; // Defer this script
                    }
                }
            }

            if (src) {
                for (const keyword of deferralConfig.srcDefer) {
                    if (src.includes(keyword)) {
                        return true; // Defer this script
                    }
                }
            }

            // Check analytics class
            if (node.className === "analytics") {
                return true;
            }

            return false; // Default: don't defer
        }

        // Optimized dataset copying function
        function copyDataset(source, target) {
            try {
                // Use Object.assign for better performance when possible
                if (source.dataset && Object.keys(source.dataset).length > 0) {
                    Object.assign(target.dataset, source.dataset);
                }
            } catch (error) {
                // Fallback to individual property copying if Object.assign fails
                for (const key in source.dataset) {
                    try {
                        target.dataset[key] = source.dataset[key];
                    } catch (e) {
                        console.warn(`Skipping dataset property '${key}' due to error:`, e);
                    }
                }
            }
        }

        // Combined MutationObserver for better performance
        let combinedObserver;

        function handleNodeMutation(node) {
            if (node.nodeType !== 1) return; // Only process element nodes

            const tagName = node.tagName;

            // Handle lazy loading for specific platforms
            if (shouldApplyLazyLoading) {
                if (tagName === "IFRAME") {
                    node.setAttribute("loading", "lazy");
                    node.setAttribute("data-src", node.src);
                    node.removeAttribute("src");
                } else if (tagName === "IMG" && imageCount++ > 15) {
                    node.setAttribute("loading", "lazy");
                } else if (tagName === "SCRIPT") {
                    node.setAttribute("data-src", node.src);
                    node.removeAttribute("src");
                    node.type = "text/lazyload";
                }
            }

            // Handle script deferral optimization
            if (pageConditions.shouldOptimize && !pageConditions.noOptimization && !pageConditions.isCartPage) {
                if (tagName === "SCRIPT" && shouldDeferScript(node)) {
                    node.type = "text/spdnscript";
                }
            }
        }

        // Create the combined observer
        if (shouldApplyLazyLoading || (pageConditions.shouldOptimize && !pageConditions.noOptimization && !pageConditions.isCartPage)) {
            combinedObserver = new MutationObserver((mutations) => {
                mutations.forEach(({ addedNodes }) => {
                    addedNodes.forEach(handleNodeMutation);
                });
            });

            combinedObserver.observe(document.documentElement, {
                childList: true,
                subtree: true,
            });
        }

        // Deferred script execution system
        const spdn_t = ["mouseover", "keydown", "touchmove", "touchstart", "wheel"];
        const perfEntries = performance.getEntriesByType("navigation");

        function triggerDeferredExecution() {
            if (combinedObserver) {
                combinedObserver.disconnect();
            }
            cleanupEventListeners();
            spdn_t.forEach(function (spdnt) {
                window.removeEventListener(spdnt, triggerDeferredExecution, { passive: true });
            });
            executeDeferredScripts();
        }

        function cleanupEventListeners() {
            if (perfEntries[0]["loadEventEnd"] > 0 && typeof document.removeEventListeners !== "undefined") {
                document.removeEventListeners("DOMContentLoaded");
                document.removeEventListeners("load");
            }
        }

        function executeSequentially(tasks, callback, index = 0) {
            if (!Array.isArray(tasks) || tasks.length === 0 || index >= tasks.length) {
                callback();
                return;
            }

            if (typeof tasks[index] === 'function') {
                tasks[index](function () {
                    executeSequentially(tasks, callback, index + 1);
                });
            } else {
                callback();
            }
        }

        function dispatchEvents() {
            if (perfEntries[0]["loadEventEnd"] > 0) {
                const events = [
                    { name: "DOMContentLoaded", target: [window, document] },
                    { name: "readystatechange", target: [window, document] },
                    { name: "load", target: [window, document] },
                    { name: "show", target: [window, document] }
                ];

                events.forEach(({ name, target }) => {
                    const event = document.createEvent("Event");
                    event.initEvent(name, true, true);
                    target.forEach(t => t.dispatchEvent(event));
                });

                // Dispatch resize event
                const resizeEvent = document.createEvent("UIEvents");
                resizeEvent.initUIEvent("resize", true, true, window, 0);
                window.dispatchEvent(resizeEvent);
                document.dispatchEvent(resizeEvent);
            }
        }

        function createAndExecuteScript(originalScript, callback) {
            const newScript = document.createElement("script");
            newScript.type = "text/javascript";
            newScript.id = originalScript.id;
            newScript.async = false;

            if (originalScript.src) {
                newScript.onload = callback;
                newScript.onerror = callback;
                newScript.src = originalScript.src;
            } else {
                newScript.textContent = originalScript.innerText;
            }

            // Copy dataset efficiently
            copyDataset(originalScript, newScript);

            originalScript.parentNode.removeChild(originalScript);
            document.body.appendChild(newScript);

            if (!originalScript.src) callback();
        }

        function executeDeferredScripts() {
            const deferredScripts = document.querySelectorAll("script[type='text/spdnscript']");
            const scriptTasks = [];

            deferredScripts.forEach(script => {
                scriptTasks.push(function (callback) {
                    createAndExecuteScript(script, callback);
                });
            });

            if (scriptTasks.length > 0) {
                executeSequentially(scriptTasks, dispatchEvents);
            } else {
                dispatchEvents();
            }
        }

        // Set up event listeners for user interaction
        spdn_t.forEach(function (eventType) {
            window.addEventListener(eventType, triggerDeferredExecution, { passive: true });
        });

        // Optimized element movement to head
        const querySelector = (selector) => document.querySelector(selector);
        const startTime = Date.now();

        function moveElementsToHead() {
            // Performance timeout after 500ms
            if (Date.now() - startTime > 500) {
                return;
            }

            if (!querySelector("body > meta")) {
                return setTimeout(moveElementsToHead, 5);
            }

            // Batch DOM operations for better performance
            const headElement = querySelector("head");
            const elementsToMove = document.querySelectorAll("meta, link:not([rel='stylesheet']), title");

            // Use document fragment for efficient DOM manipulation
            const fragment = document.createDocumentFragment();
            elementsToMove.forEach(elem => fragment.appendChild(elem));
            headElement.appendChild(fragment);
        }

        moveElementsToHead();

    } catch (error) {
        // Silently catch and ignore errors to prevent script breakage
    }
})();